// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__16Jyu","col":"styles_col__17EgE"};